import React from 'react';
import { Typography, Divider } from 'antd';
import '../../../Styles/ResearchLabs.css';

const { Title } = Typography;

const facebookPage = 'https://www.facebook.com/SDSSLab';
const facebookEmbed = `https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(facebookPage)}&tabs=timeline&width=400&height=560&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true`;

const SocialFeedSection = () => (
  <section className="sdssl-social-section">
    <div className="sdssl-social-inner">
      <Title level={2} className="sdssl-social-title">Social Feed</Title>
      <Divider className="ncgsa-divider" />
      <div className="sdssl-facebook-frame-wrap">
        <iframe
          title="Spatial Decision Support System Lab Facebook feed"
          src={facebookEmbed}
          className="sdssl-facebook-frame"
          width="400"
          height="560"
          scrolling="no"
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
          loading="lazy"
        />
      </div>
      <a href={facebookPage} target="_blank" rel="noreferrer" className="sdssl-facebook-fallback">
        View Spatial Decision Support System Lab on Facebook
      </a>
    </div>
  </section>
);

export default SocialFeedSection;
